import { Controller } from "@hotwired/stimulus"

// Usage: data-controller="expand-image" data-action="click->expand-image#toggle"
//        data-expand-image-target="img"
export default class extends Controller {
  static values = {
    expanded: { type: Boolean, default: false }
  }

  toggle(event) {
    event?.preventDefault()
    this.expandedValue = !this.expandedValue
    if (this.expandedValue) {
      if (this.legacyPoiPhoto) {
        this.element.classList.add("poi-photo-extended")
        this.element.classList.remove("poi-photo-thumb")
      } else {
        this.element.classList.add("photo-fullscreen")
        document.body.classList.add("photo-fullscreen-open")
        document.addEventListener("keydown", this.closeOnEscape)
      }
    } else {
      this.close()
    }
  }

  connect() {
    this.legacyPoiPhoto = this.element.classList.contains("poi-photo-thumb")
    this.closeOnEscape = (event) => {
      if (event.key === "Escape") this.close()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
    document.body.classList.remove("photo-fullscreen-open")
  }

  close() {
    this.expandedValue = false
    this.element.classList.remove("photo-fullscreen")
    if (this.legacyPoiPhoto) {
      this.element.classList.add("poi-photo-thumb")
      this.element.classList.remove("poi-photo-extended")
    }
    document.body.classList.remove("photo-fullscreen-open")
    document.removeEventListener("keydown", this.closeOnEscape)
  }
}
